import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, from, Observable, of, tap } from 'rxjs';
import { BrandService } from 'brand';
import { CmsService } from 'prismic';
import { MetaService } from 'utils';

export const categoryResolver: ResolveFn<Observable<unknown>> = next => {
  const cms = inject(CmsService);
  const meta = inject(MetaService);
  const brand = inject(BrandService);
  const categoryId = (next.params.category as string).slice(0, 16);
  return from(cms.getById(categoryId, '*')).pipe(
    tap(category => {
      meta.setTitle(`${brand.brandName} - ${category.data.title}`);
    }),
    catchError(() => {
      return of(null);
    })
  );
};
